import { Link } from "react-router-dom";

interface ArrowLinkProps {
  to: string;
  children: string;
  tone?: "dark" | "light";
  className?: string;
}

export default function ArrowLink({ to, children, tone = "dark", className = "" }: ArrowLinkProps) {
  const base = tone === "dark" ? "text-foreground-950" : "text-background-50";
  const line = tone === "dark" ? "bg-foreground-950/30" : "bg-background-50/30";

  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-2 font-heading text-[12px] font-semibold uppercase tracking-[0.16em] ${base} ${className}`}
    >
      <span className="relative">
        {children}
        <span
          className={`absolute -bottom-1 left-0 h-[1px] w-full origin-left scale-x-100 transition-transform duration-300 group-hover:scale-x-0 ${line}`}
        />
        <span className="absolute -bottom-1 left-0 h-[1px] w-full origin-left scale-x-0 bg-primary-500 transition-transform duration-300 delay-100 group-hover:scale-x-100" />
      </span>
      <span className="flex h-6 w-6 items-center justify-center rounded-full border border-current transition-colors duration-300 group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-background-50">
        <i className="ri-arrow-right-up-line text-[13px]" />
      </span>
    </Link>
  );
}